import i18next from 'i18next';
import fileDownload from 'js-file-download';
import axios from 'axios';
import cookies from 'js-cookie';
import { message } from 'antd';
import endpoints from '~settings/endpoints';
import { cookieNames } from '~constants';
import {
  bookingLandlordStatus,
  secondaryLandlordBookingStatus,
} from '~constants/reconciliation-booking';
import { dayFormatType, formatDay, moment } from '~helpers/day';

export const dateToString = dt => {
  // datetime class   //'yyyy-MM-dd'
  if (dt.format) {
    return dt.format(dayFormatType.CONTENTDATE);
  }
  return '';
};
export const stringDateFormat = dt => (dt ? formatDay(dayFormatType.UKFORMAT, dt) : '-');
export const SE2Str = arr => {
  if (arr.length === 2) {
    if (!arr[0].format) {
      // eslint-disable-next-line
      arr[0] = moment(arr[0]);
    }
    if (!arr[1].format) {
      // eslint-disable-next-line
      arr[1] = moment(arr[1]);
    }
    return `${dateToString(arr[0])} - ${dateToString(arr[1])}`;
  }
  return arr.length;
};

export const getSecondaryStatus = status1 => {
  const NOT_SPECIFIC_SECONDARY_STATUS = null;

  // 该方法对应的状态  必须和翻译文件里顺序一样。。
  let result = {
    value: [],
    keys: [],
  };
  switch (status1) {
    case bookingLandlordStatus.PENDING_APPROVAL:
      result = {
        keys: [
          secondaryLandlordBookingStatus.PENDING_START,
          secondaryLandlordBookingStatus.CASE_ASSIGNED,
          secondaryLandlordBookingStatus.CASE_DONE,
          secondaryLandlordBookingStatus.CASE_CLOSED,
        ],
        value: i18next
          .t('cms.reconciliation.booking.status.utils.sencondary.pending_approval')
          .split(','),
      };
      break;
    case bookingLandlordStatus.APPROVED:
      result = {
        keys: [
          secondaryLandlordBookingStatus.APPROVED_BREAK_LEASE,
          secondaryLandlordBookingStatus.FULLY_APPROVED,
        ],
        value: i18next.t('cms.reconciliation.booking.status.utils.sencondary.approved').split(','),
      };
      break;
    case bookingLandlordStatus.PARTIAL_INVOICED:
      result = {
        keys: [NOT_SPECIFIC_SECONDARY_STATUS, secondaryLandlordBookingStatus.CREDIT_NOTE],
        value: i18next
          .t('cms.reconciliation.booking.status.utils.sencondary.partial_invoiced')
          .split(','),
      };
      break;
    case bookingLandlordStatus.INVOICED:
      result = {
        keys: [NOT_SPECIFIC_SECONDARY_STATUS, secondaryLandlordBookingStatus.CREDIT_NOTE],
        value: i18next.t('cms.reconciliation.booking.status.utils.sencondary.invoiced').split(','),
      };
      break;
    case bookingLandlordStatus.PAID:
      result = {
        keys: [NOT_SPECIFIC_SECONDARY_STATUS, secondaryLandlordBookingStatus.CREDIT_NOTE],
        value: i18next.t('cms.reconciliation.booking.status.utils.sencondary.paid').split(','),
      };
      break;
    case bookingLandlordStatus.UNCLAIMABLE:
      result = {
        keys: [
          secondaryLandlordBookingStatus.NO_BOOKING_PROOF,
          secondaryLandlordBookingStatus.AGENT_CLASH,
          secondaryLandlordBookingStatus.CAP_REACHED,
          secondaryLandlordBookingStatus.ZERO_COMMISSION,
          secondaryLandlordBookingStatus.REBOOKER,
          secondaryLandlordBookingStatus.SHORT_STAY,
          secondaryLandlordBookingStatus.MISCELLANEOUS,
          secondaryLandlordBookingStatus.TENANCY_TAKEOVER,
          secondaryLandlordBookingStatus.BOOKING_PROCESS,
          secondaryLandlordBookingStatus.UNCLAIMABLE_BREAK_LEASE,
        ],
        value: i18next
          .t('cms.reconciliation.booking.status.utils.sencondary.unclaimable')
          .split(','),
      };
      break;
    default:
      break;
  }
  result.getValueByKey = function (key) {
    const index = result.keys.indexOf(key);
    return index > -1 ? result.value[index] : '';
  };
  return result;
};

export const getMainStatus = () => {
  // 该方法对应的状态  必须和翻译文件里顺序一样。。
  const result = {
    keys: [
      bookingLandlordStatus.READY_FOR_APPROVAL,
      bookingLandlordStatus.PENDING_APPROVAL,
      bookingLandlordStatus.APPROVED,
      bookingLandlordStatus.READY_TO_INVOICE,
      bookingLandlordStatus.PARTIAL_INVOICED,
      bookingLandlordStatus.INVOICED,
      bookingLandlordStatus.PAID,
      bookingLandlordStatus.CANCELLED,
      bookingLandlordStatus.NO_SHOW,
      bookingLandlordStatus.UNCLAIMABLE,
    ],
    value: i18next.t('cms.reconciliation.booking.status.utils.main').split(','),
    getValueByKey(key) {
      const index = result.keys.indexOf(key);
      return index > -1 ? result.value[index] : '';
    },
  };

  return result;
};

export const getFilterOpportunityStage = () => {
  const result = {
    keys: ['COMPLETED', 'CANCELLATION'],
    value: i18next.t('cms.reconciliation.booking.status.utils.opportunity_stages').split(','),
    getValueByKey(key) {
      const index = result.keys.indexOf(key);
      return index > -1 ? result.value[index] : '';
    },
  };

  return result;
};

export const getListingMoveInType = type => {
  const moveintype = ['EXACTLY_MATCH', 'AFTER', 'ANYTIME', 'BEFORE'];
  const typeValue = i18next.t('cms.reconciliation.booking.status.utils.movetype').split(',');
  const index = moveintype.findIndex(m => m === type);
  return index > -1 ? typeValue[index] : '-';
};

export const getDailyStr = type => {
  const moveintype = ['DAILY', 'WEEKLY', 'MONTHLY'];
  const typeValue = i18next.t('cms.reconciliation.booking.status.utils.daily').split(',');
  const index = moveintype.findIndex(m => m === type);
  return index > -1 ? typeValue[index] : '-';
};

export const getGender = type => {
  const moveintype = ['FEMALE', 'MALE'];
  const typeValue = i18next.t('cms.reconciliation.booking.status.utils.gender').split(',');
  const index = moveintype.findIndex(m => m === type);
  return index > -1 ? typeValue[index] : '-';
};

export const getPendingReason = () => {
  const result = {
    keys: [
      'STUDENT_CANCELLATION',
      'STUDENT_NO_SHOW',
      'INCOMPLETE',
      'NO_BOOKING_PROOF',
      'AGENT_CLASH',
      'CAP_REACHED',
      'ZERO_COMMISSION',
      'REBOOKER',
      'SHORT_STAY',
      'MISCELLANEOUS',
      'BREAK_LEASE',
      'BOOKING_PROCESS',
      'TENANCY_TAKEOVER',
    ],
    value: i18next.t('cms.reconciliation.booking.status.utils.pending_reason').split(','),
    //
    getValueByKey(key) {
      const index = result.keys.indexOf(key);
      return index > -1 ? result.value[index] : '';
    },
  };

  return result;
};

export const downloadExcelFile = fileName =>
  axios({
    method: 'GET',
    url: endpoints.downloadOpportunityBulkUpdateExcel.url(fileName),
    headers: {
      Authorization: `Bearer ${cookies.get(cookieNames.token)}`,
    },
    responseType: 'blob',
  })
    .then(res => {
      fileDownload(res.data, fileName);
    })
    .catch(err => {
      console.log('download excel file error: ', err);
      message.error(i18next.t('cms.reconciliation.booking.bulk_update_modal.download.error'));
    });
